// pipe is super useful: https://medium.com/javascript-scene/reduce-composing-software-fe22f0c39a1d
export default (...functions) => (x) => functions.reduce((y, func) => func(y), x);
